document.addEventListener('alpine:init', () => {
  Alpine.data('videosGrid', () => ({
    videos: [],
    isOpen: false,
    popup: null,
    mainIframe: null,

    init() {
      this.close = this.close.bind(this);

      this.$nextTick(() => {
        this.videos = this.$el.querySelectorAll('.video');

        this.videos.forEach((video, index) => {
          video.querySelector('.video__cover').addEventListener('click', (event) => {
            event.preventDefault();
            this.open(index);
          });
        });

        this.popup = this.$refs.popup;
        this.mainIframe = this.$refs.iframe;
        this.$el.after(this.popup);
        this.popup.setAttribute('x-data', '');
      });
    },

    open(index) {
      const iframe = this.videos[index].querySelector('iframe');
      this.mainIframe.src = `https://player.vimeo.com/video/${iframe.dataset.vimeoId}?autoplay=1&title=0&byline=0&portrait=0`;
      this.isOpen = true;
      this.popup.classList.add('open');
    },

    close() {
      this.mainIframe.removeAttribute('src');
      this.isOpen = false;
      this.popup.classList.remove('open');
    },

    getIframe() {
      return this.$el.nextElementSibling.querySelector('iframe');
    },
  }));
});